var map = {
	"./logo-applepay.png": "./src/assets/img/payment-logo/logo-applepay.png",
	"./logo-creditcard.png": "./src/assets/img/payment-logo/logo-creditcard.png",
	"./logo-intella-alipay.png": "./src/assets/img/payment-logo/logo-intella-alipay.png",
	"./logo-intella-linepay.png": "./src/assets/img/payment-logo/logo-intella-linepay.png",
	"./logo-intella-wechatpay.png": "./src/assets/img/payment-logo/logo-intella-wechatpay.png",
	"./logo-linepay.png": "./src/assets/img/payment-logo/logo-linepay.png",
	"./logo-owlpay-checkout.svg": "./src/assets/img/payment-logo/logo-owlpay-checkout.svg",
	"./logo-paynow-creditcard.png": "./src/assets/img/payment-logo/logo-paynow-creditcard.png",
	"./logo-paynow-creditcard3d.png": "./src/assets/img/payment-logo/logo-paynow-creditcard3d.png",
	"./logo-paypal.png": "./src/assets/img/payment-logo/logo-paypal.png",
	"./logo-sony.png": "./src/assets/img/payment-logo/logo-sony.png",
	"./logo-stripe-futurepay.png": "./src/assets/img/payment-logo/logo-stripe-futurepay.png",
	"./logo-stripe-singlepay.png": "./src/assets/img/payment-logo/logo-stripe-singlepay.png",
	"./logo-taiwan-travel.png": "./src/assets/img/payment-logo/logo-taiwan-travel.png",
	"./logo-unionpay.png": "./src/assets/img/payment-logo/logo-unionpay.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/payment-logo sync recursive ^\\.\\/logo\\-.*$";